import styled from 'styled-components';
import { Body } from 'components/Typography';
import addAlpha from 'utils/addAlpha';

// TODO: TFR-44 move to container group or do not export
export const Container = styled.div`
  display: flex;
  align-items: center;
`;

// TODO: TFR-45:DataContainer make unique name or do not export
export const DataContainer = styled.div`
  width: 100%;
`;

// TODO: TFR-50 make proper title. Data in invalid value
export const Data = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 1.1875rem;
  margin-left: 2.375rem;
  :not(:last-child) {
    margin-bottom: 1.3125rem;
  }
`;

// TODO: TFR-44 move to container group or do not export
export const NameContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

// TODO: TFR-45:Name make unique name or do not export
export const Name = styled(Body)`
  font-weight: 600;
  color: ${({ theme }) => theme.colors.navyGreen};
  margin-left: 0.75rem;
`;

export const Amount = styled(Body)`
  color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.8)};
`;

// TODO: TFR-44 looks similar to component/Status could be united and reused
export const ColoredDot = styled.div`
  background-color: ${(props) => props.color};
  border-radius: 50%;
  width: 0.75rem;
  height: 0.75rem;
`;
